import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import ResponsiveLayout from '../../../Layouts/ResponsiveLayout';
import CardItem from './CardItem/CardItem';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const ViewClassworkSubmissions = (props) => {

    const { classcode, classwork_id } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [classwork, setClasswork] = useState(null);

    async function fetchClassworkSubmissions() {

        try {

            const response = await axiosConfig.get(`/classworkSubmissions/${classwork_id}`); 
            const { data } = response.data;

            console.log(response.data);

            setClasswork(data);

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {

        if (!classcode || !classwork_id) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 1});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchClassworkSubmissions();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout classcode={classcode}>
            <Box mt={2} />

            { classwork ? (
                <Grid 
                    container 
                    spacing={2}
                    // justify="center"
                >
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h6">
                            {`${classwork.title} ${classwork.is_graded ? ' - Graded' : ''} (${classwork.work_type})`} | Due date: {classwork.due_date || 'N/A'}
                        </Typography>
                        
                        <Typography>{classwork.description}</Typography>
                        
                        <Box mt={2} />

                        <Typography>Attachment/s:</Typography>

                        { classwork.attachments ? (
                            <Box style={{marginLeft: -5}}>
                                <Button
                                    size="small" 
                                    color="primary" 
                                    // href="http://www.africau.edu/images/default/sample.pdf"
                                    href={classwork.attachments_url || ''}
                                    target="_blank"
                                    download
                                >
                                    { classwork.attachments || ''}
                                </Button>
                            </Box>) : '' 
                        }

                        {classwork.files && classwork.files.map((file, i) => (
                            <Box style={{marginLeft: -5}} key={i}>
                                <Button
                                    size="small" 
                                    color="primary" 
                                    // href="http://www.africau.edu/images/default/sample.pdf"
                                    href={file.file_url || ''}
                                    target="_blank"
                                    download
                                >
                                    { file.file_name || ''}
                                </Button>
                            </Box>
                        ))}

                        { !classwork.attachments && !classwork.files ? (
                            'No attachment/s available'
                        ) : ''}
    
                        <Box mt={1} />
    
                        <Box style={{display: 'inline-block', borderLeft: '1px solid #CECECE'}} px={2} my={1}>
                            <Typography variant="h4">{`${classwork.turned_in}`}</Typography>
                            <Typography variant="subtitle1" style={{fontSize: '12px'}}>Turned In</Typography>
                        </Box>
    
                        <Box style={{display: 'inline-block', borderLeft: '1px solid #CECECE'}} px={2} my={1}>
                            <Typography variant="h4">{`${classwork.assigned}`}</Typography>
                            <Typography variant="subtitle1" style={{fontSize: '12px'}}>Assigned</Typography>
                        </Box>
                    </Grid>

                    {classwork.students && classwork.students.map((student, i) => (
                        <CardItem
                            key={student.id}
                            student={student}
                            classwork={classwork}
                        />
                    ))}

                </Grid>
            ) : null}

        </ResponsiveLayout>
    );
}

export default ViewClassworkSubmissions;